import React from 'react';
import { FileText, Shield, CheckCircle2 } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

export default function TermsOfService() {
  return (
    <div className="bg-[#070E1B] text-white min-h-screen font-opensans flex flex-col justify-between">
      <SEOHead 
        title="Terms of Service | Grow & Stay Rich"
        description="Review the Terms of Service, user agreements, and educational boundary conditions governing Grow & Stay Rich advisory tools and website access."
        path="/terms"
      />

      <div>
        <Navigation />

        <div className="relative pt-24 pb-16 border-b border-[#C9A84C]/25 overflow-hidden">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#162236] border border-[#C9A84C]/30 text-xs font-semibold text-[#E8D4A0] tracking-wider uppercase">
              <FileText className="w-4 h-4 text-[#C9A84C]" />
              Website & Consultation Terms
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold font-playfair text-white">Terms of Service</h1>
            <p className="text-sm text-slate-300">Effective Date: January 1, 2026 • Last Updated: August 2026</p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-8 text-sm text-slate-300 leading-relaxed font-opensans">
          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">1. Agreement to Terms</h2>
            <p>
              By accessing the website, scheduling financial consultations, downloading educational wealth blueprints, or attending live masterclasses hosted by Grow & Stay Rich ("we," "our," or "us"), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our services or website.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">2. Educational & Advisory Boundary Condition</h2>
            <p>
              Grow & Stay Rich provides general financial education, strategy concepts, and state-licensed life insurance and fixed annuity illustrations. All content provided on this website is for informational and educational purposes. Formal insurance product quotes, policy issuance, and contractual guarantees require individualized underwriting evaluation and execution of carrier-specific application forms.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">3. State Licensing & Jurisdiction</h2>
            <p>
              Advisory consultation services are restricted to jurisdictions where our licensed professionals hold valid insurance producer licenses (Texas [Primary NPN: 21450620], California, Colorado, Florida, Idaho, Illinois, Kansas, Ohio, and South Carolina). Nothing on this site shall be construed as a solicitation or offer to sell insurance products in any state where such offer or solicitation would be unlawful.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">4. Intellectual Property</h2>
            <p>
              All proprietary logos, wealth blueprint guides, masterclass slide decks, design system tokens, and software code on GrowAndStayRich.com are the exclusive intellectual property of Grow & Stay Rich and protected under applicable trademark and copyright laws.
            </p>
          </section>

          <section className="bg-[#0D1B2A]/90 border border-[#C9A84C]/25 p-8 rounded-2xl space-y-4">
            <h2 className="text-xl font-bold font-playfair text-[#E8D4A0]">5. Contact Information</h2>
            <div className="font-mono text-xs bg-[#162236] p-4 rounded-xl border border-[#C9A84C]/20 text-slate-300">
              Grow & Stay Rich Legal & Advisory Support<br />
              2019 Holy Unity Ln, St Paul, TX-75098<br />
              Phone: (903) 231-3051 • Email: info@growandstayrich.com
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
